export default __webpack_public_path__ + "static/tanulo_2-a88c43c53fae449e885ee97de8710c5e.webp";